import { render, staticRenderFns } from "./InventoryLeaseReturnStatus.vue?vue&type=template&id=2016582d&scoped=true"
import script from "./InventoryLeaseReturnStatus.vue?vue&type=script&lang=js"
export * from "./InventoryLeaseReturnStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2016582d",
  null
  
)

export default component.exports